import { render, staticRenderFns } from "./AftSaleItem.vue?vue&type=template&id=e0bdbdf8&scoped=true&"
import script from "./AftSaleItem.vue?vue&type=script&lang=js&"
export * from "./AftSaleItem.vue?vue&type=script&lang=js&"
import style0 from "./AftSaleItem.vue?vue&type=style&index=0&id=e0bdbdf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bdbdf8",
  null
  
)

export default component.exports